/** Figma home widget cards use Roboto (not legacy Work Sans). */
export const HOME_WIDGET_FONT_FAMILY = 'Roboto, sans-serif';
